/* ERROR */
export const SEND_REQUEST_FAILURE = "SEND_REQUEST_FAILURE";

export const CLEAR_REQUEST_FAILURE = "CLEAR_REQUEST_FAILURE";

export const SHOW_LOADING = "SHOW_LOADING"

//#region ********************************************************* USERS
export const SUCCESS_POST_LOGIN = "SUCCESS_POST_LOGIN";
export const SUCCESS_POST_GOOGLE_LOGIN = "SUCCESS_POST_GOOGLE_LOGIN";
export const POST_LOGIN = "POST_LOGIN";
export const POST_GOOGLE_LOGIN = "POST_GOOGLE_LOGIN";

export const SUCCESS_POST_LOGOUT = "SUCCESS_POST_LOGOUT";
export const POST_LOGOUT = "POST_LOGOUT";

export const SUCCESS_POST_REGISTER = "SUCCESS_POST_REGISTER";
export const POST_REGISTER = "POST_REGISTER";

export const SUCCESS_GET_RETRIEVE_USER = "SUCCESS_GET_RETRIEVE_USER";
export const GET_RETRIEVE_USER = "GET_RETRIEVE_USER";

export const ERROR_LOGIN = "ERROR_LOGIN";

export const SUCCESS_POST_CONFIRM_USER = "SUCCESS_POST_CONFIRM_USER";
export const POST_CONFIRM_USER = "POST_CONFIRM_USER";

export const SUCCESS_GET_VALIDATE_USERNAME = "SUCCESS_GET_VALIDATE_USERNAME";
export const GET_VALIDATE_USERNAME = "GET_VALIDATE_USERNAME";

export const SUCCESS_POST_PASSWORD_RECOVER = "SUCCESS_POST_PASSWORD_RECOVER";
export const POST_PASSWORD_RECOVER = "POST_PASSWORD_RECOVER";

export const SUCCESS_PUT_RESET_PASSWORD = "SUCCESS_PUT_RESET_PASSWORD";
export const PUT_RESET_PASSWORD = "PUT_RESET_PASSWORD";

export const SUCCESS_POST_UPDATE_PROFESSIONAL = "SUCCESS_PUT_UPDATE_PROFESSIONAL"
export const POST_UPDATE_PROFESSIONAL = "PUT_UPDATE_PROFESSIONAL"

export const CLEAR_ERROR_LOGIN = "CLEAR_ERROR_LOGIN"

export const GET_ALL_USERS = "GET_ALL_USERS";
export const SUCCESS_GET_ALL_USERS = "SUCCESS_GET_ALL_USERS";

export const GET_DETAIL_USER = "GET_DETAIL_USER";
export const SUCCESS_GET_DETAIL_USER = "SUCCESS_GET_DETAIL_USER";

export const ERROR_USERS = "ERROR_USERS";
//#endregion

//#region ********************************************************* PRODUCTS
export const SUCCESS_GET_PRODUCTS = "SUCCESS_GET_PRODUCTS";
export const GET_PRODUCTS = "GET_PRODUCTS";

export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";

export const SUCCESS_GET_PRODUCTS_ADMIN = "SUCCESS_GET_PRODUCTS_ADMIN";
export const GET_PRODUCTS_ADMIN = "GET_PRODUCTS_ADMIN";

export const SUCCESS_POST_PRODUCTS = "SUCCESS_POST_PRODUCTS";
export const POST_PRODUCTS = "POST_PRODUCTS";

export const CLEAR_POST_PRODUCT = "CLEAR_POST_PRODUCT";

export const SUCCESS_POST_PRODUCTS_IGEN = "SUCCESS_POST_PRODUCTS_IGEN";
export const POST_PRODUCTS_IGEN = "POST_PRODUCTS_IGEN";

export const SUCCESS_PUT_PRODUCTS = "SUCCESS_PUT_PRODUCTS";
export const PUT_PRODUCTS = "PUT_PRODUCTS";

export const CLEAR_PUT_PRODUCT = "CLEAR_PUT_PRODUCT";

export const SUCCESS_GET_PRODUCTS_BY_CATEGORY = "SUCCESS_GET_PRODUCTS_BY_CATEGORY";
export const GET_PRODUCTS_BY_CATEGORY = "GET_PRODUCTS_BY_CATEGORY";

export const SUCCESS_GET_PRODUCTS_BY_SUBCATEGORY = "SUCCESS_GET_PRODUCTS_BY_SUBCATEGORY";
export const GET_PRODUCTS_BY_SUBCATEGORY = "GET_PRODUCTS_BY_SUBCATEGORY";

export const SUCCESS_GET_PRODUCT_ID = "SUCCESS_GET_PRODUCT_ID";
export const GET_PRODUCT_ID = "GET_PRODUCT_ID";

export const SUCCESS_POST_CREATE_IMAGE = "SUCCESS_POST_CREATE_IMAGE";
export const POST_CREATE_IMAGE = "POST_CREATE_IMAGE";

export const SUCCESS_GET_SEARCHER_PRODUCTS = "SUCCESS_GET_SEARCHER_PRODUCTS";
export const GET_SEARCHER_PRODUCTS = "GET_SEARCHER_PRODUCTS";

export const CLEAR_SEARCHER_PRODUCTS = "CLEAR_SEARCHER_PRODUCTS";

export const SUCCESS_PUT_PRODUCT_CHANGE_STATUS = "SUCCESS_PUT_PRODUCT_CHANGE_STATUS";
export const PUT_PRODUCT_CHANGE_STATUS = "PUT_PRODUCT_CHANGE_STATUS";

export const SUCCESS_GET_SEARCHER_PRODUCTS_ADMIN = "SUCCESS_GET_SEARCHER_PRODUCTS_ADMIN";
export const GET_SEARCHER_PRODUCTS_ADMIN = "GET_SEARCHER_PRODUCTS_ADMIN";

export const ERROR_PRODUCT = "ERROR_PRODUCT";

export const POST_CHANGE_PRODUCT_PRICE_MASIVE = "POST_CHANGE_PRODUCT_PRICE_MASIVE";
//#endregion

//#region ********************************************************* CATEGORIES
export const SUCCESS_GET_CATEGORIES = "SUCCESS_GET_CATEGORIES";
export const GET_CATEGORIES = "GET_CATEGORIES";

export const SUCCESS_GET_CATEGORIES_SUBCATEGORIES = "SUCCESS_GET_CATEGORIES_SUBCATEGORIES";
export const GET_CATEGORIES_SUBCATEGORIES = "GET_CATEGORIES_SUBCATEGORIES";

export const SUCCESS_POST_CATEGORY = "SUCCESS_POST_CATEGORY";
export const POST_CATEGORY = "POST_CATEGORY";

export const SUCCESS_PUT_CATEGORY = "SUCCESS_PUT_CATEGORY";
export const PUT_CATEGORY = "PUT_CATEGORY";

export const SUCCESS_DELETE_CATEGORY = "SUCCESS_DELETE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";

export const SUCCESS_GET_CATEGORY_SUBCATEGORIES = "SUCCESS_GET_CATEGORY_SUBCATEGORIES";
export const GET_CATEGORY_SUBCATEGORIES = "GET_CATEGORY_SUBCATEGORIES";

export const SUCCESS_POST_CREATE_CATEGORY_SUBCATEGORY = "SUCCESS_POST_CREATE_CATEGORY_SUBCATEGORY";
export const POST_CREATE_CATEGORY_SUBCATEGORY = "POST_CREATE_CATEGORY_SUBCATEGORY";

export const ERROR_CATEGORY = 'ERROR_CATEGORY'
//#endregion

//#region ********************************************************* SUBCATEGORIES
export const SUCCESS_GET_SUBCATEGORIES = "SUCCESS_GET_SUBCATEGORIES";
export const GET_SUBCATEGORIES = "GET_SUBCATEGORIES";

export const SUCCESS_POST_SUBCATEGORY = "SUCCESS_POST_SUBCATEGORY";
export const POST_SUBCATEGORY = "POST_SUBCATEGORY";

export const SUCCESS_PUT_SUBCATEGORY = "SUCCESS_PUT_SUBCATEGORY";
export const PUT_SUBCATEGORY = "PUT_SUBCATEGORY";

export const SUCCESS_DELETE_SUBCATEGORY = "SUCCESS_DELETE_SUBCATEGORY";
export const DELETE_SUBCATEGORY = "DELETE_SUBCATEGORY";

export const ERROR_SUBCATEGORY = 'ERROR_SUBCATEGORY'
//#endregion

//#region ********************************************************* SHIPPING
export const SUCCESS_POST_QUANTITY_PACKAGE = "SUCCESS_POST_QUANTITY_PACKAGE";
export const POST_QUANTITY_PACKAGE = "POST_QUANTITY_PACKAGE";

export const SUCCESS_PUT_MANUAL_UPDATE_SHIPPING = "SUCCESS_PUT_MANUAL_UPDATE_SHIPPING";
export const PUT_MANUAL_UPDATE_SHIPPING = "PUT_MANUAL_UPDATE_SHIPPING";

export const CLEAR_MANUAL_UPDATE_SHIPPING = "CLEAR_MANUAL_UPDATE_SHIPPING";

export const SUCCESS_GET_QUOTE_SHIPPING = "SUCCESS_GET_QUOTE_SHIPPING";
export const GET_QUOTE_SHIPPING = "GET_QUOTE_SHIPPING";

export const CLEAR_QUOTE_SHIPPING = "CLEAR_QUOTE_SHIPPING"

export const ERROR_SHIPPING = 'ERROR_SHIPPING'
//#endregion

//#region ********************************************************* ADDRESS
export const SUCCESS_POST_ADDRESS = "SUCCESS_POST_ADDRESS";
export const POST_ADDRESS = "POST_ADDRESS";

export const SUCCESS_GET_PROVINCES = "SUCCESS_GET_PROVINCES";
export const GET_PROVINCES = "GET_PROVINCES";

export const SUCCESS_GET_ADDRESS_ID = "SUCCESS_GET_ADDRESS_ID";
export const GET_ADDRESS_ID = "GET_ADDRESS_ID";

export const ERROR_ADDRESS = 'ERROR_ADDRESS'
//#endregion

//#region ********************************************************* ORDERS
export const SUCCESS_POST_ORDERS = "SUCCESS_POST_ORDERS";
export const POST_ORDERS = "POST_ORDERS";

export const SUCCESS_GET_ORDERS = "SUCCESS_GET_ORDERS";
export const GET_ORDERS = "GET_ORDERS";

export const SUCCESS_GET_ORDER_CUSTOMER = "SUCCESS_GET_ORDER_CUSTOMER";
export const GET_ORDER_CUSTOMER = "GET_ORDER_CUSTOMER";

export const SUCCESS_GET_ORDER_DETAIL = "SUCCESS_GET_ORDER_DETAIL";
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL";

export const CLEAR_ORDERS = "CLEAR_ORDERS";

export const CLEAR_POST_ORDER = "CLEAR_POST_ORDER";

export const ERROR_ORDERS = 'ERROR_ORDERS'
//#endregion

//#region ********************************************************* BRANDS
export const SUCCESS_GET_BRAND = "SUCCESS_GET_BRAND";
export const GET_BRAND = "GET_BRAND";

export const SUCCESS_POST_BRAND = "SUCCESS_POST_BRAND";
export const POST_BRAND = "POST_BRAND";

export const SUCCESS_PUT_BRAND = "SUCCESS_PUT_BRAND";
export const PUT_BRAND = "PUT_BRAND";

export const SUCCESS_POST_BRAND_CHANGE_STATUS = "SUCCESS_POST_BRAND_CHANGE_STATUS";
export const POST_BRAND_CHANGE_STATUS = "POST_BRAND_CHANGE_STATUS";

export const ERROR_BRANDS = 'ERROR_BRANDS'
//#endregion

//#region ********************************************************* RESOURCE
export const SUCCESS_DELETE_IMAGE_PRODUCT = "SUCCESS_DELETE_IMAGE_PRODUCT";
export const DELETE_IMAGE_PRODUCT = "DELETE_IMAGE_PRODUCT";
//#endregion

//#region ********************************************************* STATISTICS
export const SUCCESS_GET_STATISTICS = "SUCCESS_GET_STATISTICS";
export const GET_STATISTICS = "GET_STATISTICS";

export const ERROR_STATISTICS = "ERROR_STATISTICS";

//#region ********************************************************* PRESCRIPTION
export const CLEAR_REDUCER_PRESCRIPTION = "CLEAR_REDUCER_PRESCRIPTION"
export const ERROR_PRESCRIPTION = "ERROR_PRESCRIPTION";

export const POST_PRESCRIPTION = "POST_PRESCRIPTION";
export const SUCCESS_POST_PRESCRIPTION = "SUCCESS_POST_PRESCRIPTION";

export const GET_DETAIL_PRESCRIPTION = "GET_DETAIL_PRESCRIPTION";
export const SUCCESS_GET_DETAIL_PRESCRIPTION = "SUCCESS_GET_DETAIL_PRESCRIPTION";

export const PRINT_PRESCRIPTION = "PRINT_PRESCRIPTION";
export const SUCCESS_PRINT_PRESCRIPTION = "SUCCESS_PRINT_PRESCRIPTION";

export const GET_ALL_PRESCRIPTIONS = "GET_ALL_PRESCRIPTIONS";
export const SUCCESS_GET_ALL_PRESCRIPTIONS = "SUCCESS_GET_ALL_PRESCRIPTIONS";

//#endregion

